export default {
  Start: 'Loading',
  Complete: 'Finished Loading.',
  Fail: 'Loading Failed.',
};
